import client from './client';

/**
 * Get current user's payroll authorities
 * @returns {Promise} API response with payroll authorities data
 */
export const getMyPayrollAuthorities = async () => {
  try {
    const res = await client.get('/payroll-authorities/me');
    return res.data;
  } catch (error) {
    console.error('Error fetching payroll authorities:', error);
    throw error;
  }
};

/**
 * Save or update current user's payroll authorities
 * @param {Object} data - Payroll authorities data
 * @param {string} [data.payroll_analyst] - Payroll Analyst name
 * @param {string} [data.payroll_officer] - Payroll Officer name
 * @param {string} [data.payroll_manager] - Payroll Manager name
 * @param {string} [data.director_finance_dept] - Director Finance Dept name
 * @param {string} [data.president] - President name
 * @returns {Promise} API response with saved payroll authorities data
 */
export const savePayrollAuthorities = async (data) => {
  try {
    const res = await client.post('/payroll-authorities', data);
    return res.data;
  } catch (error) {
    console.error('Error saving payroll authorities:', error);
    throw error;
  }
};




